import { render } from "./ReasonView.vue?vue&type=template&id=ecfcaf86&scoped=true&ts=true"
import script from "./ReasonView.vue?vue&type=script&lang=ts"
export * from "./ReasonView.vue?vue&type=script&lang=ts"

import "./ReasonView.vue?vue&type=style&index=0&id=ecfcaf86&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfcaf86"]])

export default __exports__